import {safeDefineElement} from "@/scripts/core/global";
import {AnnouncementBar} from "@/scripts/header/AnnouncementBar";
import {MenuDrawer} from "@/scripts/header/MenuDrawer";
import {StickyHeader} from "@/scripts/header/StickyHeader";

safeDefineElement(AnnouncementBar)
safeDefineElement(MenuDrawer)
safeDefineElement(StickyHeader)
